module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_96-5b6936a36af36bc0014c7f5861ac6d0a.png";